import { TokenR, TokenC } from '../types/types';
import { callApi } from './api';

class TokensService {
  async getUserTokens(userId: number): Promise<TokenR[]> {
    return callApi({ url: `/users/${userId}/tokens/` });
  }

  async createToken(data: TokenC): Promise<TokenR> {
    return callApi({
      url: `/users/${data.userId}/tokens/`,
      method: 'POST',
      data: { description: data.description }
    });
  }

  async regenerateToken(tokenId: number, userId: number): Promise<TokenR> {
    return callApi({
      url: `/users/${userId}/tokens/${tokenId}/regenerate/`,
      method: 'POST'
    });
  }

  async deleteToken(tokenId: number, userId: number): Promise<void> {
    return callApi({
      url: `/users/${userId}/tokens/${tokenId}/`,
      method: 'DELETE'
    });
  }
}

export const tokensService = new TokensService();
